import { render, staticRenderFns } from "./AliPay.vue?vue&type=template&id=631d8625&scoped=true&"
import script from "./AliPay.vue?vue&type=script&lang=js&"
export * from "./AliPay.vue?vue&type=script&lang=js&"
import style0 from "./AliPay.vue?vue&type=style&index=0&id=631d8625&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "631d8625",
  null
  
)

export default component.exports